// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import EmployeesController from "./employees_controller"
application.register("employees", EmployeesController)

import BranchesController from "./branches_controller"
application.register("branches", BranchesController)

import ItemsController from "./items_controller"
application.register("items", ItemsController)

import ItemsSearchController from "./items_search_controller"
application.register("items-search", ItemsSearchController)

import Notification from "@stimulus-components/notification"
application.register("notification", Notification)

import HamburgerMenuController from "./hamburger_menu_controller"
application.register("hamburger-menu", HamburgerMenuController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import CsvUploadController from "./csv_upload_controller"
application.register("csv-upload", CsvUploadController)

import OutboundsController from "./outbounds_controller"
application.register("outbounds", OutboundsController)

import StockCsvExportsController from "./stock_csv_exports_controller"
application.register("stock-csv-exports", StockCsvExportsController)

import DeliveryConfirmationsController from "./delivery_confirmations_controller"
application.register("delivery-confirmations", DeliveryConfirmationsController)

import DeliveryConfirmationModalController from "./delivery_confirmation_modal_controller"
application.register("delivery-confirmation-modal", DeliveryConfirmationModalController)

import ItemQuantityCalculatorController from "./item_quantity_calculator_controller"
application.register("item-quantity-calculator", ItemQuantityCalculatorController)

import SetQuantityCalculatorController from "./set_quantity_calculator_controller"
application.register("set-quantity-calculator", SetQuantityCalculatorController)

import StockConfirmationsController from "./stock_confirmations_controller"
application.register("stock-confirmations", StockConfirmationsController)

import CarryForwardsController from "./carry_forwards_controller"
application.register("carry-forwards", CarryForwardsController)

import StockManagementSheetsController from "./stock_management_sheets"
application.register("stock-management-sheets", StockManagementSheetsController)

import FadeInController from "./fade_in_controller"
application.register("fade-in", FadeInController)

